// The shared "Merlin" mark: the family wizard logo in a circle, ringed with the
// per-Merlin accent colour. Every Merlin uses the SAME logo — the accent ring
// (and the role chip in the switcher) are what tell the specialists apart.

import { MERLIN_AVATAR } from '../../constants/merlins';

interface MerlinMarkProps {
  /** Ring colour — the per-Merlin accent. */
  accent: string;
  /** Square tile size in px. Default 20. */
  size?: number;
  className?: string;
}

export default function MerlinMark({ accent, size = 20, className }: MerlinMarkProps) {
  // Ring scales with the mark but stays visible at tiny nav sizes.
  const ring = Math.max(1.5, Math.round(size * 0.09));
  return (
    <span
      className={className}
      aria-hidden="true"
      data-testid="merlin-mark"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: `${ring}px solid ${accent}`,
        boxSizing: 'border-box',
        backgroundColor: '#fff',
        backgroundImage: `url("${MERLIN_AVATAR}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'inline-block',
        flex: '0 0 auto',
      }}
    />
  );
}
